import React from 'react';
import {
  Box,
  Typography,
  Button,
  Paper,
  alpha,
  useTheme
} from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

const DemoProgressCTA = ({ onCTAClick, questionNumber, totalQuestions }) => {
  const theme = useTheme();
  
  // Different messages based on progress
  const getProgressMessage = () => {
    const progress = (questionNumber / totalQuestions) * 100;
    
    if (progress <= 30) {
      return {
        headline: "Loving this so far?",
        subtext: "Get unlimited practice exams just like this one",
        ctaText: "Get Early Access"
      };
    } else if (progress <= 60) {
      return {
        headline: "You're doing great!",
        subtext: "Keep building confidence with personalized practice",
        ctaText: "Get Early Access"
      };
    } else {
      return {
        headline: "Almost there!",
        subtext: "Ready for unlimited custom exams?",
        ctaText: "Get Early Access"
      };
    }
  };
  
  const { headline, subtext, ctaText } = getProgressMessage();
  
  return (
    <Box sx={{ mt: 4, mb: 2 }}>
      <Paper
        sx={{
          p: 3,
          background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.05)}, ${alpha(theme.palette.secondary.main, 0.05)})`,
          border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
          borderRadius: 2,
          textAlign: 'center',
          position: 'relative',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: 3,
            background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
          }
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}>
          <TrendingUpIcon sx={{ color: theme.palette.primary.main, mr: 1 }} />
          <Typography 
            variant="h6" 
            sx={{ 
              fontWeight: 600,
              color: theme.palette.text.primary
            }}
          >
            {headline}
          </Typography>
        </Box>
        
        <Typography 
          variant="body1" 
          sx={{ 
            mb: 3,
            color: theme.palette.text.secondary,
            maxWidth: 400,
            mx: 'auto'
          }}
        >
          {subtext}
        </Typography>
        
        <Button
          variant="contained"
          startIcon={<AutoAwesomeIcon />}
          onClick={onCTAClick}
          sx={{
            px: 4,
            py: 1.5,
            borderRadius: 3,
            fontWeight: 600,
            fontSize: '1rem',
            textTransform: 'none',
            background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
            '&:hover': {
              background: `linear-gradient(45deg, ${theme.palette.primary.dark}, ${theme.palette.secondary.dark})`,
              transform: 'translateY(-2px)',
              boxShadow: theme.shadows[8]
            },
            transition: 'all 0.3s ease'
          }}
        >
          {ctaText}
        </Button>
        
        <Typography 
          variant="caption" 
          sx={{ 
            display: 'block',
            mt: 2,
            color: theme.palette.text.secondary,
            fontStyle: 'italic'
          }}
        >
          Question {questionNumber} of {totalQuestions} • Keep going!
        </Typography>
      </Paper>
    </Box>
  );
};

export default DemoProgressCTA;